import { render } from "./DeliveryStatusModal.vue?vue&type=template&id=42d0f44e&scoped=true"
import script from "./DeliveryStatusModal.vue?vue&type=script&lang=js"
export * from "./DeliveryStatusModal.vue?vue&type=script&lang=js"

import "./DeliveryStatusModal.vue?vue&type=style&index=0&id=42d0f44e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d0f44e"]])

export default __exports__